import { PieChart, Pie, Cell, ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip, Legend } from "recharts";

const COLORS = ["#2FA39F", "#8BC34A", "#F59E0B"];

export function MacroPie({ totals }) {
  const kcal_p = (totals.protein || 0) * 4;
  const kcal_f = (totals.fat || 0) * 9;
  const kcal_c = (totals.carb || 0) * 4;
  const total = kcal_p + kcal_f + kcal_c || 1;
  const data = [
    { name: "Protein", value: Math.round(kcal_p), pct: Math.round((kcal_p / total) * 100) },
    { name: "Lemak", value: Math.round(kcal_f), pct: Math.round((kcal_f / total) * 100) },
    { name: "Karbohidrat", value: Math.round(kcal_c), pct: Math.round((kcal_c / total) * 100) },
  ];
  return (
    <div className="h-56" data-testid="macro-pie">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={40} outerRadius={70} paddingAngle={2}
            label={(e) => `${e.pct}%`} labelLine={false}>
            {data.map((_, i) => <Cell key={i} fill={COLORS[i]} />)}
          </Pie>
          <Tooltip formatter={(v, n, p) => [`${v} kcal (${p.payload.pct}%)`, n]} contentStyle={{ borderRadius: 8, border: "1px solid #2FA39F33" }}/>
          <Legend verticalAlign="bottom" iconType="circle" wrapperStyle={{ fontSize: 11 }}/>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export function NutrientRadar({ percentages }) {
  const data = [
    { k: "Protein", pct: Math.min(200, percentages.protein || 0) },
    { k: "Karbo", pct: Math.min(200, percentages.carb || 0) },
    { k: "Lemak", pct: Math.min(200, percentages.fat || 0) },
    { k: "Serat", pct: Math.min(200, percentages.fiber || 0) },
    { k: "Kalsium", pct: Math.min(200, percentages.calcium || 0) },
    { k: "Fe", pct: Math.min(200, percentages.iron || 0) },
    { k: "Vit A", pct: Math.min(200, percentages.vit_a || 0) },
    { k: "Vit C", pct: Math.min(200, percentages.vit_c || 0) },
  ];
  return (
    <div className="h-64" data-testid="nutrient-radar">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#2FA39F22"/>
          <PolarAngleAxis dataKey="k" tick={{ fontSize: 10, fill: "#5C7575" }}/>
          <PolarRadiusAxis angle={90} domain={[0, 150]} tick={{ fontSize: 9, fill: "#5C7575" }}/>
          <Radar name="% AKG" dataKey="pct" stroke="#2FA39F" fill="#2FA39F" fillOpacity={0.35}/>
          <Tooltip formatter={(v) => `${v}%`} contentStyle={{ borderRadius: 8, border: "1px solid #2FA39F33" }}/>
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
